import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Moment from 'react-moment';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../generics/help';
import { donationTypeExtraction, pdfIMSS } from '../../libs/services';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../config');

class MonthlyApheresis extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.setTable = this.setTable.bind(this);

		this.state = {
			start_date 	: "",
			end_date 	: "",
			listado:[],
			filename:"Informe Mensual de Aféresis",

			totals:[],
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			//health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	async componentDidMount(){
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		this.$el = $(this.el);

        var obj = {
            start_date: this.state.start_date,
            end_date: this.state.end_date,
        };

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
                
				{
                	extend: 'excelHtml5',
                	title: this.state.filename,
                	action: (e, dt, node, config)=>{
                        this.props.printExcelReport(this.state.filename, 'monthly_apheresis', obj);
                    }
            	},
                {
                    text:'PDF',
                    action: (e, dt, node, config)=>{
                        this.props.printPdfIMSSReports('monthly_apheresis', obj);
                    }
                }
            ],
			data: this.state.listado,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
			},
			columnDefs:[{
				targets: [0,1,2,3,4,5,6],
				 className:'dt-center'
			 }],
			paging:false,
			ordering:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.dt-button').disable();
		}else {
			table.buttons('.dt-button').enable();
		}
	}

	handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});
		
		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	searching(){

		if(this.isValidForm()){
			if(this.dateCompare()){
				this.props.waiting.handleShow('Buscando...');

				var obj = {
					start_date: this.state.start_date,
					end_date: this.state.end_date,
				}
				
                var fecha1 = moment(this.state.start_date);
				var fecha2 = moment(this.state.end_date);

				var dias = fecha2.diff(fecha1, 'days');

                if(dias <= 31){
                    fetch(Config.default.apiGateway.URL+'reports_imss/monthly_apheresis',{
                        method: 'POST',
                        body:JSON.stringify(obj),
                        headers: new Headers({
                            'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                            'Accept'		: 'application/json',
                            'Content-Type'	: 'application/json'
                        })
                    }).then(res => {
                        
                        if(res.ok){
                            return res.json();
                        }else{
                            this.props.waiting.handleClose();
                            res.text().then((msg)=>{
                                swal('Error', msg, 'error');
                            });
                        }
                    }).then(response => {
                        if(response !== undefined){
                            var list = [];
                            
							response.details.forEach((res)=>{
								var row = [
									res.day+'/'+(res.month < 10 ? '0'+res.month : res.month),
									res.doble,
									res.sencilla,
									res.doble + res.sencilla,
									res.eritro,
									res.leuco,
									res.cph
								];

								list.push(row);
							});

							list.push(['','','','','','','']);
							
							list.push([
								'Total',
								response.totals.doble,
								response.totals.sencilla,
								response.totals.doble + response.totals.sencilla,
								response.totals.eritro,
								response.totals.leuco,
								response.totals.cph
							]);
							

                            this.setState({
                                listado: list,
                            });

                            setTimeout(()=>{
                                this.props.waiting.handleShow('Cargando...');
                                this.$el = $(this.el);
                                this.$el.DataTable().destroy();
                                //this.$el.empty();
                            }, 500);

                            setTimeout(()=>{
                                this.props.waiting.handleClose();
                                this.setTable();
                            }, 1000);
                        
                                
                            this.props.waiting.handleClose();
                        }
                    });
                }else{
					this.props.waiting.handleClose();
                    swal('Error', 'La diferencia entre las fechas es de '+dias+' dias, la diferencia maxima entre la fecha desde y la fecha hasta debe ser de 31 dias', 'error')
                }
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_imss"} 
		            submenu={"help_monthly_apheresis"}  />

				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>												
                                <div className="form-group">
                                    <span className="span-min">Fecha Desde</span>
                                    <input type="date" className="form-control hour-input" name="start_date" id="start_date"
                                        value={this.state.start_date} onChange={this.handleChange} required />
                                </div>
                                <div className="form-group">
                                    <span className="span-min">Fecha Hasta</span>
                                    <input type="date" className="form-control hour-input" name="end_date" id="end_date"
                                        value={this.state.end_date} onChange={this.handleChange} required />
                                </div>									
							
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>

								</div>

								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
                                            <thead>
                                                <tr>
                                                    <th className='center' rowSpan={3}>Dia</th>
                                                    <th className='center' colSpan={3}>Donantes Aféresis Plaquetarias</th>
                                                    <th className='center' colSpan={3}>Donantes</th>
                                                </tr>
                                                <tr>
                                                    <th className='center' colSpan={3}>Efectivos</th>
                                                    <th className='center' colSpan={3}>Efectivos</th>
                                                </tr>
                                                <tr>
                                                    <th className='center'>Dobles</th>
                                                    <th className='center'>Sencillas</th>
                                                    <th className='center'>Total</th>
                                                    <th className='center'>Eritroaféresis</th>
                                                    <th className='center'>Leucoaféresis</th>
                                                    <th className='center'>CPH</th>
                                                </tr>
                                            </thead>
										</table>
									</div>
									
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (MonthlyApheresis);